export default "__VITE_ASSET__DoYblx58__"